// extracted by mini-css-extract-plugin
export default {"wrapper":"HeroCarousel_wrapper__5Ib6m","slide":"HeroCarousel_slide__wXSIn","active":"HeroCarousel_active__YuPQL"};